<template>
  <el-button icon="el-icon-printer" size="small" type="secondary" @click="() => $emit('click')"></el-button>
</template>

<script>
export default {
  name: 'PrintDocument',
};
</script>



// WEBPACK FOOTER //
// src/components/PrintDocument.vue